import Converter from './Converter';
import { CasinoType, ICasinoProviderConfigurationItem } from 'modules/Casino/types/configuration';
import { projectName } from 'modules/Casino/utils/slots';
import { parseCookies } from '../../utils/parseCookies';
import { QueryTypes } from 'modules/Casino/types/enums/api';
import { shortLanguages } from 'services/locale';

const converter = new Converter();

export const config: ICasinoProviderConfigurationItem<Converter> = {
  type: CasinoType.slots,
  gameListUrl: 'pgsoft_original/game_list',
  converter,
  gameListUrlData: {
    getHeaders: () => ({
      'Content-Type': 'application/json',
      headers: {
        'x-partner-name': projectName,
      },
    }),
  },
  sessionUrlData: {
    url: 'pgsoft_original/game_link',
    method: QueryTypes.GET,
    converter: converter.convertGameUrl,
    getBody: params => ({
      lang: shortLanguages[params.lang as keyof typeof shortLanguages],
      game_id: params.gameId,
      lobby_url: location.origin.includes('http://localhost')
        ? 'https://ganamos.net/slots?sP=pgsoft'
        : `${location.origin}/slots?sP=pgsoft`,
      platform: 'web',
    }),
    getHeaders: () => ({
      headers: {
        'x-partner-name': projectName,
        'x-partner-authorization': parseCookies(),
      },
    }),
  },
};
